import styled, { css } from 'styled-components'

interface CustomButton {
    backgroundColor: string
    borderConfiguration: string
    textColor: string
    minSize?: string
}

export const CustomButton = styled.button<CustomButton>`
    width: fit-content;
    min-width: ${props => props.minSize};
    height: 30px;
    background: ${props => props.backgroundColor};
    color: ${props => props.textColor};
    border: ${props => props.borderConfiguration};
    border-radius: 4px;
    font-size: 12px;
`

export const ConfirmCustomButton = styled.button`
    width: fit-content;
    min-width: 101px;
    height: 30px;
    background: var(--red-500);
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 700;
`

export const ChannelsConfigurationBtn = styled.button<{ enabled?: boolean }>`
    width: 100%;
    height: 36px;
    padding: 0 16px;

    font-size: 13px;
    font-weight: 600;

    border: 1px solid var(--gray-400);
    border-radius: 4px;

    cursor: pointer;
    background-color: transparent;

    &:disabled,
    &[disabled] {
        background-color: #242c37 !important;
    }

    ${({ enabled }) =>
        !enabled &&
        css`
            color: var(--gray-500);
            cursor: not-allowed;
        `}
`

export const Cancel = styled.a`
    margin-left: 4px;
`
